<template>
  <div class="c-car-selection__type">
    <car-price :price="xcSession.car.price" />

    <h2>{{ xcSession.car.make + " " + xcSession.car.model }}</h2>
    <picture class="c-car-selection__image">
      <img :src="xcSession.car.imageUrl" />
    </picture>

    <div class="c-car-selection__info">
      <div class="c-car-selection__field">
        <label>{{
            messages["bofi_calculate_monthly_amount_car_info_price"]
          }}</label>
        <span>&euro; {{ formattedPrice }}</span>
      </div>
      <div class="c-car-selection__field">
        <label>{{
            messages["bofi_calculate_monthly_amount_car_info_licence_plate"]
          }}</label>
        <span>{{ formattedLicensePlate }}</span>
      </div>
      <div class="c-car-selection__field">
        <label>{{
            messages["bofi_calculate_monthly_amount_car_info_mileage"]
          }}</label>
        <span>{{ formattedMileage }} km</span>
      </div>
      <div class="c-car-selection__field">
        <label>{{
            messages["bofi_calculate_monthly_amount_car_info_construction_year"]
          }}</label>
        <span>{{
            formattedBuildMonth + " " + xcSession.car.buildYear
          }}</span>
      </div>
      <div class="c-car-selection__field">
        <label>{{
            messages["bofi_calculate_monthly_amount_car_info_insurance"]
          }}</label>
        <span>BOVAG Garantie</span>
      </div>
    </div>
  </div>
</template>
<script>
import * as Api from "../../api";
import { CarPrice } from "../../includes";
import * as BofiUtils from "../../utils";

export default {
  name: "CarDisplay",
  components: {
    CarPrice,
  },
  data() {
    return {
      messages: {
        bofi_calculate_monthly_amount_car_info_price: "Verkoopprijs",
        bofi_calculate_monthly_amount_car_info_licence_plate: "Kenteken",
        bofi_calculate_monthly_amount_car_info_mileage: "Kilometers",
        bofi_calculate_monthly_amount_car_info_construction_year: "Bouwjaar",
        bofi_calculate_monthly_amount_car_info_insurance: "Garantie",
      },
      xcSession: {
        car: {
          imageUrl: "",
          buildMonth: 1,
          buildYear: "",
          make: "",
          model: "",
          mileage: "",
          price: 0,
          priceExclVatInclBpm: 0,
          licensePlate: "",
        },
      },
    };
  },
  beforeMount() {
    Api.Credit.getCalculationData().then(data => {
      this.xcSession.car.buildMonth = data.buildMonth;
      this.xcSession.car.buildYear = data.buildYear;
      this.xcSession.car.imageUrl = data.imageUrl;
      this.xcSession.car.make = data.make;
      this.xcSession.car.mileage = data.mileage;
      this.xcSession.car.model = data.model;
      this.xcSession.car.price = data.price;
      this.xcSession.car.licensePlate = data.licensePlate;
      this.xcSession.car.priceExclVatInclBpm = data.priceExclVatInclBpm;
    });
  },
  computed: {
    formattedPrice: function() {
      return BofiUtils.formatMoney(this.xcSession.car.price);
    },
    formattedLicensePlate: function() {
      return BofiUtils.formatLicensePlate(this.xcSession.car.licensePlate);
    },
    formattedMileage: function() {
      return BofiUtils.formatNumber(this.xcSession.car.mileage);
    },
    formattedBuildMonth: function() {
      return BofiUtils.formatMonthToText(this.xcSession.car.buildMonth);
    },
  },
};
</script>
